export default __webpack_public_path__ + "static/media/ico_link.ca33cadd.svg";